import script from "./AiAssistantSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./AiAssistantSidebar.vue?vue&type=script&setup=true&lang=js"

import "./AiAssistantSidebar.vue?vue&type=style&index=0&id=51484673&lang=scss"

const __exports__ = script;

export default __exports__